import React from 'react'
import SideBarBack from '../../components/SidebarBack'
import { useDispatch } from 'react-redux'
import {
    setDrawerActiveMenu
} from '../../store/features/webUtilitiesSlice'
import end from '../../assets/images/Subscription/end.webp'
import icon from '../../assets/images/logout/icon.png'

export default function Menu() {
    const dispatch = useDispatch()
    const handleCloseDrawer = async () => {
        await dispatch(setDrawerActiveMenu(32))
    }

    return (
        <div className='w-full h-full' >
            <div className='w-full flex mb-2'>
                <SideBarBack className="bg-transparent" handleCloseDrawer={handleCloseDrawer} />
            </div>
            <div className='flex justify-center items-center flex-col gap-2 mt-1 w-11/12 mx-auto pb-10'>
                <p className='text-2xl text-center font-medium'>Are you sure you want to<br /> <span className='text-[#FF9950]'>cancel </span>your subscription ?</p>
                <div className='flex gap-6 w-10/12'>
                    <img src={end} alt='workoutladey' />
                </div>
                <div className='cardbox text-center mt-3 relative w-full bg-[#FFBE251A] border border-[#FFBE25] shadow-md py-4 pt-6 px-6 rounded-3xl'>
                    <img
                        className='watchImg right-36 -top-5 w-9 h-9 absolute rounded-md'
                        alt='watchImg'
                        src={icon}
                    />
                    <div className='text-center'>
                        <p className='cardboxtitle text-sm'>
                            We’ll miss you...
                        </p>
                        <p className='text-[11px] mt-1'>
                            We’d love to keep helping you plan your meals, but if you decide to cancel, you can do so in your “subscription settings”. We’re here to assist you anytime. Thank you for using FastBetter !
                        </p>
                    </div>
                </div>
                <div className='flex justify-center gap-6 w-full'>
                    <button className='bg-gray-200 border border-gray-200 font-semibold text-black text-sm w-5/12 py-4 mt-6 rounded-2xl'>
                        Hmm...
                    </button>
                    <button onClick={handleCloseDrawer} className=' bg-[#FF9950] text-white font-semibold text-sm w-5/12 py-4 mt-6 rounded-2xl'>
                        Nope!
                    </button>
                </div>
            </div>
        </div>
    )
}
